import { createEntityAdapter } from "@reduxjs/toolkit";
import { PatientAddress } from "@/redux/slice/location/types/PatientAddress";

export default createEntityAdapter<PatientAddress, string>({
  selectId: (address) => address.id,
});
